import React from 'react';
import { NumericFormat } from 'react-number-format';
import TextField from '@mui/material/TextField';
import { FieldProps } from 'formik';

interface MoneyFormatCustomProps extends FieldProps {
  label: string;
  [key: string]: any; 
}

const MoneyFormatCustom: React.FC<MoneyFormatCustomProps> = ({
  field,
  form,
  ...props
}) => {
  return (
    <NumericFormat
      {...field}
      {...props}
      customInput={TextField}

      thousandSeparator="."
      decimalSeparator=","
      prefix="R$ "
      
      // Permite digitar ponto ou vírgula para ir aos centavos
      allowedDecimalSeparators={['.', ',']} 
      
      // Mantém sempre 2 casas, mas não bloqueia a edição
      decimalScale={2}
      fixedDecimalScale={true}
      
      // Seleciona tudo ao clicar (facilita corrigir valores)
      onFocus={(e) => e.target.select()}
      
      onValueChange={(values) => {
        form.setFieldValue(field.name, values.floatValue ?? '');
      }}
    />
  );
};

export default MoneyFormatCustom;